import { NgModule, Optional, SkipSelf } from '@angular/core';
import { IconsModule } from './icons/icons.module';
import { provideFuse } from '../../@fuse/fuse.provider';
import { appConfig } from './config/app.config';

@NgModule({
    imports: [IconsModule],
    providers: [
        ...provideFuse({ fuse: appConfig }),
    ],
})
export class FuseCoreModule {
    /**
     * Constructor
     */
    constructor(@Optional() @SkipSelf() parentModule?: FuseCoreModule) {
        // Do not allow multiple injections
        if (parentModule) {
            throw new Error('CoreModule has already been loaded. Import this module in the AppModule only.');
        }
    }
}
